<div class="chart-section">
  <div class="section-header">
    <div class="section-icon demography">
      <i class="bi bi-people"></i>
    </div>
    <h2 class="section-title">Audience Demographics</h2>
  </div>

  <div class="section-card">
    <div class="chart-grid">
      <!-- Gender -->
      <div class="chart-cell sample-chart">
        <div class="chart-cell-header">
          <h3>
            <i class="bi bi-gender-ambiguous cell-icon text-purple"></i>
            Gender
          </h3>
        </div>
        <div class="chart-with-legend">
          <app-audit-placeholder [type]="'profile'" [name]="'gender_tiktok'"></app-audit-placeholder>
          <div class="chart-pie-area">
            <img class="w-100" src="./assets/images/demo/demo-gender.png" alt="Gender demo"/>
          </div>
          <div class="chart-legend-area">
            <img class="w-100" src="./assets/images/demo/demo-gender.png" alt="Gender legend demo" style="opacity: 0;"/>
          </div>
        </div>
      </div>

      <!-- Age -->
      <div class="chart-cell sample-chart">
        <div class="chart-cell-header">
          <h3>
            <i class="bi bi-calendar-heart cell-icon text-coral"></i>
            Age
          </h3>
        </div>
        <div>
          <app-audit-placeholder [type]="'profile'" [name]="'age_tiktok'"></app-audit-placeholder>
          <img class="w-100" src="./assets/images/demo/demo-age.png" alt="Age demo"/>
        </div>
      </div>

      <!-- Quality Distribution -->
      <div class="chart-cell sample-chart">
        <div class="chart-cell-header">
          <h3>
            <i class="bi bi-shield-check cell-icon text-green"></i>
            Quality Distribution
          </h3>
          <p class="chart-sub">by numbers of other profiles followed</p>
        </div>
        <div class="chart-with-legend">
          <app-audit-placeholder [type]="'profile'" [name]="'quality_tiktok'"></app-audit-placeholder>
          <div class="chart-pie-area">
            <img class="w-100" src="./assets/images/demo/demo-qd.png" alt="Quality demo"/>
          </div>
          <div class="chart-legend-area">
            <img class="w-100" src="./assets/images/demo/demo-qd.png" alt="Quality legend demo" style="opacity: 0;"/>
          </div>
        </div>
      </div>

      <!-- Language -->
      <div class="chart-cell sample-chart">
        <div class="chart-cell-header">
          <h3>
            <i class="bi bi-translate cell-icon text-blue"></i>
            Language
          </h3>
        </div>
        <div>
          <app-audit-placeholder [type]="'profile'" [name]="'language_tiktok'"></app-audit-placeholder>
          <img class="w-100" src="./assets/images/demo/demo-lang.png" alt="Language demo"/>
        </div>
      </div>
    </div>
  </div>
</div>
